/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { storageFor } from 'ember-local-storage';
import { isArray } from '@ember/array';
import { tracked } from '@glimmer/tracking';
import { UserFlags } from 'cio/models/user';
import { inject as service } from '@ember/service';
import AccountService from 'cio/services/account';

interface PersistDismissalArgs {
  alertId?: string;
  disableLSKeysOnDismiss: string[];
  useUserFlags?: boolean;
  userFlag?: keyof UserFlags;
}

export default class PersistDismissal extends Component<PersistDismissalArgs> {
  @service account!: AccountService;
  @storageFor('cio-alerts') localStorage: any;

  @tracked _isVisible = false;

  get useUserFlags() {
    return this.args.useUserFlags ?? false;
  }

  constructor(owner: unknown, args: PersistDismissalArgs) {
    super(owner, args);

    if (!this.useUserFlags && (args.alertId == null || args.alertId === '')) {
      throw new Error('You must provide an `alertId` for a dismissable alert');
    } else if (this.useUserFlags && args.userFlag == null) {
      throw new Error('You must provide a `userFlag` for a dismissable alert');
    }

    this._toggleVisibility();
  }

  _toggleVisibility() {
    this._isVisible = this.checkIsVisible();
  }

  _dismiss() {
    if (this.args.useUserFlags && this.args.userFlag != null) {
      this.account.current.currentUser.userFlags = {
        ...this.account.current.currentUser.userFlags,
        [this.args.userFlag]: false,
      };
      // This issues an async request, but we don't want to wait for the result
      // of it - we want to proceed to closing the modal
      this.account.current.currentUser.updateUserFlags({});
    } else {
      this.localStorage.set(this.args.alertId, false);

      if (isArray(this.args.disableLSKeysOnDismiss)) {
        this.args.disableLSKeysOnDismiss.forEach((key) => this.localStorage.set(key, false));
      }
    }

    this._toggleVisibility();
  }

  @action
  dismissAlert() {
    this._dismiss();
  }

  private checkIsVisible() {
    if (this.args.useUserFlags && this.args.userFlag != null) {
      return this.account.current?.currentUser?.userFlags[this.args.userFlag] ?? false;
    } else {
      return this.localStorage.get(this.args.alertId) !== false;
    }
  }
}
